import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Vuelidate from 'vuelidate';
import './assets/fonts/font.css';
import { MedTransGoConstants } from './util/constants';
import { ToastEvent } from './types/event';
import VCalendar from 'v-calendar';
import VSelect from 'vue-select';
import 'vue-search-select/dist/VueSearchSelect.css';
import 'vue-select/dist/vue-select.css';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import posthog from 'posthog-js';
Vue.use(VCalendar, {
  componentPrefix: 'vc',
});
Vue.use(VSelect);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.component('multiselect', Multiselect);


Vue.config.productionTip = false;
const apiKey = process.env.VUE_APP_POSTHUG_API_KEY ? process.env.VUE_APP_POSTHUG_API_KEY : '';
posthog.init(apiKey, {
  api_host: 'https://us.posthog.com',
});
export const EventBus = new Vue();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');


// Toast event
EventBus.$on(MedTransGoConstants.EVENT_SHOW_TOAST, (toastEvent: ToastEvent) => {
  EventBus.$bvToast.toast(toastEvent.message, {
    title: toastEvent.title,
    autoHideDelay: toastEvent.timeout,
    appendToast: false,
    variant: toastEvent.varient,
  });
});
